import { defineEvent } from '../types/event';
export var OPTIMIZELY_NEW_VISITOR_SEGMENT = defineEvent({
    platforms: [
        {
            name: 'Heap'
        }
    ]
});
